export default [
  {
    code: 'uk',
    country: 'United Kingdom'
  },
  {
    code: 'us',
    country: 'United States'
  },
  {
    code: 'ca',
    country: 'Canada'
  },
  {
    code: 'de',
    country: 'Germany'
  },
  {
    code: 'jp',
    country: 'Japan'
  },
  {
    code: 'ie',
    country: 'Ireland'
  },
  {
    code: 'es',
    country: 'Spain'
  },
  {
    code: 'fr',
    country: 'France'
  },
  {
    code: 'it',
    country: 'Italy'
  },
  {
    code: 'nl',
    country: 'Netherlands'
  },
  {
    code: 'se',
    country: 'Sweden'
  },
  {
    code: 'ch',
    country: 'Switzerland'
  },
  {
    code: 'at',
    country: 'Australia'
  },
  {
    code: 'sg',
    country: 'Singapore'
  },
  {
    code: 'br',
    country: 'Brazil'
  },
  {
    code: 'hk',
    country: 'Hong Kong'
  },
  {
    code: 'dk',
    country: 'Denmark'
  },
  {
    code: 'no',
    country: 'Norway'
  },
  {
    code: 'mx',
    country: 'Mexico'
  },
  {
    code: 'in',
    country: 'India'
  },
  {
    code: 'nz',
    country: 'New Zealand'
  },
  {
    code: 'rou',
    country: 'Romania'
  }
]



// WEBPACK FOOTER //
// ./src/data/tunnels.js